import { api } from "./api";
import type { PhoneChangeRequest } from "@screens/Onboarding/types";

export const requestPhoneChange = async (
  _cpDbId: string,
  newPhoneNumber: string,
): Promise<{ id: number; message: string }> => {
  const { data } = await api.post("/cpdb/phone-change/request", {
    new_phone_number: newPhoneNumber,
  });
  return data;
};

export const getPhoneChangeStatus = async (
  _requestId: string,
): Promise<PhoneChangeRequest> => {
  throw new Error("PHONE_CHANGE_STATUS_NOT_IMPLEMENTED");
};
